import { booleanAttribute, Directive, HostBinding, Input } from '@angular/core'

@Directive({ selector: '[appLabel]' })
export class LabelDirective {

    @HostBinding('class.app-label')
    public hasBaseClass: boolean = true

    @HostBinding('class.app-label--required')
    @Input({ transform: booleanAttribute })
    public required: boolean = false
}
